import { format, parse } from "date-fns";
// returns undefined if the value is blank
// returns null if the value is invalid
const DETECT_MONTH_DAY_YEAR = /^\d{2}\/\d{2}\/\d{4}$/;
const DETECT_ISO = /^\d{4}-\d{2}-\d{2}$/;
const FORMAT_MONTH_DAY_YEAR = "MM/dd/yyyy";
const FORMAT_ISO = "yyyy-MM-dd";
export function convertToDate(value) {
    if (value instanceof Date) {
        return value;
    }
    if (typeof value !== "string") {
        return null;
    }
    if (!value) {
        return undefined;
    }
    if (DETECT_MONTH_DAY_YEAR.test(value)) {
        return parse(value, FORMAT_MONTH_DAY_YEAR, new Date());
    }
    if (DETECT_ISO.test(value)) {
        return parse(value, FORMAT_ISO, new Date());
    }
    return null;
}
export function formatDateMonthDayYear(value) {
    if (value instanceof Date) {
        return format(value, FORMAT_MONTH_DAY_YEAR);
    }
    if (!value || typeof value !== "string") {
        return "";
    }
    if (DETECT_MONTH_DAY_YEAR.test(value)) {
        return value;
    }
    if (DETECT_ISO.test(value)) {
        return format(parse(value, FORMAT_ISO, new Date()), FORMAT_MONTH_DAY_YEAR);
    }
    return "";
}
export function formatDateIso(value) {
    if (value instanceof Date) {
        return format(value, FORMAT_ISO);
    }
    if (!value || typeof value !== "string") {
        return "";
    }
    if (DETECT_ISO.test(value)) {
        return value;
    }
    if (DETECT_MONTH_DAY_YEAR.test(value)) {
        return format(parse(value, FORMAT_MONTH_DAY_YEAR, new Date()), FORMAT_ISO);
    }
    return "";
}
export function mapTermFormatToFormatter(dateFormat) {
    return dateFormat === "iso" ? formatDateIso : formatDateMonthDayYear;
}
//# sourceMappingURL=date-utils.js.map